import RecipeConseils from './RecipeConseils';

export default RecipeConseils;
